export default __webpack_public_path__ + "static/media/Zais_logo.ef879876.png";